import React, { useCallback, useState } from 'react';
import ShareDivePrompt from '../components/ShareDivePrompt';
import { diveService } from '../services/diveService';

/**
 * After a bulk import (Suunto sync, FIT/UDDF file) the usual per-dive "share it?" prompt would
 * either fire dozens of times or never, so offer a single nudge for the most recent dive
 * instead. Call offerShare() only when the import added new dives; render `prompt` once.
 */
export function useShareLatestDive() {
  const [diveId, setDiveId] = useState<string | null>(null);

  const offerShare = useCallback(async () => {
    try {
      const dives = await diveService.getMyDives();
      const latest = dives.reduce<(typeof dives)[number] | null>(
        (best, d) => (!best || new Date(d.startTime) > new Date(best.startTime) ? d : best),
        null
      );
      if (latest) setDiveId(latest.id);
    } catch {
      // The prompt is a nicety — a failed lookup must never surface as an import error.
    }
  }, []);

  const prompt = (
    <ShareDivePrompt
      diveId={diveId}
      title="Dives imported! Share your latest with your buddies?"
      onClose={() => setDiveId(null)}
    />
  );

  return { offerShare, prompt };
}
